module.exports = __webpack_public_path__ + "img/online-trx.6c24c305.svg";